/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import type { Menu, Page, Reference } from '@swf/cms';
import { useCMSReference } from '@swf/cms';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

import styles from './CMSNavigationSubmenu.scss';
import { TXTCLI_Show_More_Options } from './CMSNavigationSubmenuChildren.messages.json';
import CMSNavigationSubmenuItem from './CMSNavigationSubmenuItem';

interface Props {
  parentUrl?: string;
  parentPageRef?: Reference[];
  menuItems: Menu[];
  onSelect: () => void;
}

const ItemLimit = 8;

const CMSNavigationSubmenuChildren: React.FC<Props> = ({
  menuItems,
  parentUrl,
  parentPageRef,
  onSelect
}) => {
  const { formatMessage } = useIntl();
  const { greaterThan } = useScreenSize();
  const page = useCMSReference<Page>(parentPageRef?.[0]);
  const parentHref = parentUrl || page?.url;

  return (
    <ul className={styles.subMenu}>
      {menuItems.map(({ heading, url, uid, page }, index) => {
        const itemLimit = greaterThan(Size.Small) && parentHref ? ItemLimit : menuItems.length;
        return (
          index <= itemLimit && (
            <li key={uid} className={styles.subMenuItem}>
              <CMSNavigationSubmenuItem
                pageRef={itemLimit === index ? parentPageRef : page}
                url={itemLimit === index ? parentUrl : url}
                heading={itemLimit === index ? formatMessage(TXTCLI_Show_More_Options) : heading}
                itemCount={itemLimit === index ? menuItems.length - itemLimit : undefined}
                className={classNames(styles.subMenuItem, {
                  [styles.showMore]: itemLimit === index
                })}
                onSelect={onSelect}
              />
            </li>
          )
        );
      })}
    </ul>
  );
};

export default CMSNavigationSubmenuChildren;
